import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { BASE_URL_Image } from '../../constants';

export default function NTMgallery() {
  return (
    <Box sx={{ px: 3, py: 0 }}>
      {/* Main Title */}
      {/* <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center' }}>
        MoUs & Strategic Partnerships
      </Typography> */}

      {/* Image Description Title */}
      <Typography variant="subtitle1" sx={{ mb: 2, textAlign: 'center', maxWidth: 900, mx: 'auto' }}>
        Signing of the Memorandum of Understanding (MoU) between GERMI and JMG Corporation Ltd. This partnership marks the beginning of a promising collaboration in the critical domains of carbon credit mechanisms, ESG integration, greenhouse gas (GHG) emission management, and broader sustainability initiatives, CBG.
      </Typography>

      {/* Single Highlight Image */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
        <img
          src={BASE_URL_Image+"Gallery/MoUs+%26+Strategic+Partnerships/01/MoU+Signed+between+GERMI+%26+JMG.jpg"} // Replace with actual MoU image
          alt="MoU Signing"
          style={{ maxWidth: '100%', height: 'auto', borderRadius: 8 }}
        />
      </Box>

    
    </Box>
  );
}

